<template>
  <div class="p-5">
    <slot></slot>
  </div>
</template>
